import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { Referral } from "./pages";

const referralRoutes = [
  {
    path: "/referral",
    element: (
      <ProtectedRoute isNotEmployee>
        <Referral />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="referral.referral" />,
  },
];

export default referralRoutes;
